import { Logger, LoggerService } from "@Shared/logger";
import { Auth0Service } from "@Modules/auth_module";
import { PipelineContext, PipelineStep } from "@Modules/pipeline_module/_base";

export class AmpRegwallStep implements PipelineStep {
    private auth0Service: Auth0Service;
    private Logger: Logger = LoggerService.createLogger("AmpRegwallStep");

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....", context);
        this.auth0Service = Auth0Service.Instance;
        await this.auth0Service.loginViaAmpRegwall();
        return null;
    }
}
